/* global appData, document */

import $ from 'jquery';
import debounce from 'lodash/debounce';

import { RestComponent } from '../../mixins/rest-component';
import { TranslatedComponent } from '../../mixins/translated-component';
import './search.scss';
import template from './search.vhtml';

let request = null;

export default {
	mixins: [
		RestComponent,
		TranslatedComponent,
	],
	template: template,
	props: {
		color: {
			type: String,
			default: '#000000',
		}
	},
	data: () => ({
		isOpen: false,
		s: '',
		results: [],
		error: '',
		selected: -1,
		isLoading: false,
	}),
	computed: {
		rgbaDarkColor() {
			const color = this.color !== '#000' ? shadeColor(this.color, -.30) : this.color; 
			return hexToRgba(color, 90);
		},
	},
	watch: {
		s(){
			this.selected = -1;
			this.error = '';
			this.search(this.s);
		},
	},
	mounted() {
		$( document ).on( 'keydown', this.handleEscapeClick );
	},
	destroyed() {
		$(document).off( 'keydown', this.handleEscapeClick );
	},
	methods: {
		open() {
			this.isOpen = true;
			setTimeout(function () { $('#searchInput', this.$el).focus(); }, 100);
		},
		close() {
			this.isOpen = false;
			this.s = '';
			this.selected = -1;
			this.resetResults();
		},
		handleEscapeClick( e ) {
			if (e.keyCode === 27) {
				this.close();
			}
		},
		navigateOnEnter() {
			if ( this.results.length > 0) {
				if ( this.selected > -1 ) {
					this.closeToNavigate(this.results[this.selected].path);
				} else {
					this.closeToNavigate(this.results[0].path);
				}
			}
		},
		closeToNavigate(path) {
			this.close();
			setTimeout(() => {
				this.openPage(path);
			}, 400);
		},
		resetResults() {
			this.results = [];
		},
		selectDown() {
			if (this.results.length > 0) {
				if (this.results.length !== this.selected + 1) {
					this.selected++;
				} else {
					this.selected = -1;
				}
			}
		},
		selectUp() {
			if (this.results.length > 0) {
				if ( this.selected > -1 ) {
					this.selected--;
				} else {
					this.selected = this.results.length - 1;
				}
			}
		},
		search: debounce(function(query) {
			if (query.length > 0 ) {
				this.isLoading = true;
				const endpoint = `${appData.root}cp/v1/search`;
				const params = {
					s: query,
					lang: this.language,
				};
				if (request) {
					request.abort();
				}
				request = $.ajax({
					type: 'GET',
					url: endpoint, 
					data: params,
				});

				request
					.then(content => content = content.map( (x, index) => Object.assign(x, {index: index}) ))
					.then(content => this.results = content)
					.catch( error => this.error = error.responseJSON.message )
					.then( () => this.isLoading = false );
			} else {
				this.error = '';
				this.resetResults();
			}
		}, 500),
	},
};

function hexToRgba(hex, opacity) {
	hex = hex.replace('#', '');
	const r = parseInt(hex.substring(0, hex.length / 3), 16);
	const g = parseInt(hex.substring(hex.length / 3, 2 * hex.length / 3), 16);
	const b = parseInt(hex.substring(2 * hex.length / 3, 3 * hex.length / 3), 16);

	const result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
	return result;
}

function shadeColor(color, percent) {
	var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
	return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
}




// WEBPACK FOOTER //
// ./assets/_js/components/search/search.js